<ws-modal-wrapper headerLabel="Add Parcel Collector"
                  [disableSave]="serverAction || collectors?.length === 0"
                  acceptLabel="Add"
                  [loading]="serverAction"
                  (save)="add()"
                  (cancel)="close()">
    <div>
        <!-- has company collectors -->
        @if (params.hasCompanyCollectors) {
            <div class="collectors-choice">
                <div class="radio">
                    <label>
                        <input type="radio"
                               [value]="true"
                               name="is-state"
                               [(ngModel)]="isStateCollector"
                               (change)="governmentalCollectorsSelected()"> Governmental Collectors
                    </label>
                </div>
                <div class="radio">
                    <label>
                        <input type="radio"
                               [value]="false"
                               name="is-state"
                               [(ngModel)]="isStateCollector"
                               (change)="companyCollectorsSelected()"> Company Collectors
                    </label>
                </div>
            </div>
        }

        <!-- has no collectors -->
        @if (collectors?.length === 0) {
            <div>
                <h3 class="text-center">No Collectors found for this parcel.</h3>
            </div>
        }

        <!-- has collectors -->
        @if (collectors?.length !== 0) {
            <div>
                <div class="mb-4">
                    <label>Collector:</label>
                    <select class="form-select form-select-sm"
                            [(ngModel)]="selectedCollector"
                            (change)="collectorChanged()">
                        @for (option of collectors; track option) {
                            <option [ngValue]="option">{{ option.title }}</option>
                        }
                    </select>
                </div>
                @if (selectedCollector) {
                    <div class="form-inline" style="padding-bottom: 10px;">
                        <label>Payment Options:</label>
                        @for (collectorBill of selectedCollector.collectorBillInfo; track collectorBill; let
                            i = $index) {
                            <div>
                                <span>{{ collectorBill.collectorBillName }} </span>Pmt Option:
                                @if (collectorBill.displayPaymentOptions.length) {
                                    <select class="form-select form-select-sm"
                                            style="min-width: 200px; margin-left: 10px; margin-bottom: 4px;"
                                            [(ngModel)]="selectedPaymentOptions[i]">
                                        @for (option of collectorBill.displayPaymentOptions; track option) {
                                            <option [ngValue]="option">
                                                {{ option.collectorPaymentOptionName }}
                                            </option>
                                        }
                                    </select>
                                }
                                @if (!collectorBill.displayPaymentOptions.length) {
                                    <span>Only single option available</span>
                                }
                            </div>
                        }
                    </div>
                }
                <div class="mb-4">
                    <label>Apply to:</label>
                    <div class="radio">
                        <label>
                            <input type="radio"
                                   [checked]="applyTo === 'all'"
                                   (change)="applyToChange($event)"
                                   name="apply-to"
                                   value="all"> All Tax Years
                        </label>
                    </div>
                    <div class="radio">
                        <label style="display: flex; gap: 10px; align-items: center;">
                            <input type="radio"
                                   [checked]="applyTo === 'year'"
                                   (change)="applyToChange($event)"
                                   name="apply-to"
                                   value="year"> Tax year
                            <select class="form-select form-select-sm"
                                    style="width: auto;"
                                    [(ngModel)]="taxYear"
                                    [disabled]="applyTo !== 'year'">
                                @for (year of taxYears; track year) {
                                    <option [ngValue]="year">{{ year }}</option>
                                }
                            </select>
                            <span>and forward</span>
                        </label>
                    </div>
                </div>
            </div>
        }
    </div>
</ws-modal-wrapper>
